export default __webpack_public_path__ + "static/media/Q5_3_resized.a991f1dc.jpg";